import apiClient, { type PagedResponse } from '../client'
import type {
  BalanceDeviceStatusResponse,
  BalanzaListItemResponse,
  LaboratorioRowResponse,
  LabAssayResponse,
  PlantAnalysisResponse,
  SaveLabAssayRequest,
  SimulateWeightCaptureResponse,
} from '../models/response'

const BASE_PATH = '/planta'

export type WeightType = 'Gross' | 'Tare'

export const plantaService = {
  async getBalanzaList(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<BalanzaListItemResponse>> {
    return apiClient.get<PagedResponse<BalanzaListItemResponse>>(`${BASE_PATH}/balanza`, params)
  },

  async getLaboratorioList(params?: {
    page?: number
    pageSize?: number
    search?: string
    status?: string
  }): Promise<PagedResponse<LaboratorioRowResponse>> {
    return apiClient.get<PagedResponse<LaboratorioRowResponse>>(`${BASE_PATH}/laboratorio`, params)
  },

  async registerWeight(
    shipmentId: string,
    type: WeightType,
    weight: number,
    source: 'Manual' | 'Iot' = 'Manual',
  ): Promise<PlantAnalysisResponse> {
    return apiClient.post<PlantAnalysisResponse>(`${BASE_PATH}/balanza/${shipmentId}/weight`, {
      type,
      weight,
      source,
    })
  },

  async getBalanceDeviceStatus(): Promise<BalanceDeviceStatusResponse> {
    return apiClient.get<BalanceDeviceStatusResponse>(`${BASE_PATH}/balanza/device/status`)
  },

  async captureSimulatedWeight(type: WeightType): Promise<SimulateWeightCaptureResponse> {
    return apiClient.post<SimulateWeightCaptureResponse>(
      `${BASE_PATH}/balanza/device/capture?type=${encodeURIComponent(type)}`,
    )
  },

  // ── Laboratorio refactor (por muestra) ──
  async getLabAssay(sampleId: string): Promise<LabAssayResponse> {
    return apiClient.get<LabAssayResponse>(`${BASE_PATH}/laboratorio/${sampleId}/assay`)
  },

  async saveLabAssay(sampleId: string, data: SaveLabAssayRequest): Promise<LabAssayResponse> {
    return apiClient.post<LabAssayResponse, SaveLabAssayRequest>(
      `${BASE_PATH}/laboratorio/${sampleId}/assay`,
      data,
    )
  },
}
